import { connect } from "react-redux";
import { IContentBySearchState, IStatus, StatusType } from "../../store";
import { NotificationBar } from "../presentation/NotificationBar";

interface PropsFromState {
    status: IStatus;
}

interface PropsFromDispatch {
}

interface OwnProps {
}

const mapPropsToState = (state: IContentBySearchState) => ({
    status: state.status
});

const mapDispatchToProps = (dispatch: any) => ({
});

export const NotificationBarContainer = connect<PropsFromState, PropsFromDispatch, OwnProps>(mapPropsToState, mapDispatchToProps)(NotificationBar);